import * as React from "react";
import { Modal, ModalBody, ModalFooter, ModalSize } from "soprasteria-ui-library";
import { IFaqQuestion } from "../../models/IFaq";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../App";
import "./FaqModal.scss";
import { FaqApi } from "../../api/FaqApi";

interface IFaqModal {
    modalData?: IFaqQuestion;
}

export const FaqModal: React.FunctionComponent<IFaqModal> = ({ modalData }) => {
    const auth = useAuth();
    const api = new FaqApi(auth);

    const renderLinks = () => {
        if (modalData?.links?.length !== 0) {
            return <div className="col-6">
                <h6>Länkar</h6>
                <ul className="list-no-styling">
                    {
                        modalData?.links?.map((link, index) =>
                            <li key={index}>
                                <a href={(link.url.includes("http://") || link.url.includes("https://")) ? link.url : "http://" + link.url}
                                    target="_blank">
                                    {link.description}
                                </a>
                            </li>
                        )
                    }
                </ul>
            </div>
        }
    }

    const renderDocuments = () => {
        if (modalData?.attachments?.length !== 0) {
            return <div className="col-8">
                <div className="row">
                    <h6 className="col-8">Filer</h6>
                    <h6 className="col-4">Ladda ner</h6>
                </div>
                <ul className="list-no-styling document-download-list">
                    {
                        modalData?.attachments?.map((file, index) =>
                            <li key={index} className="row file-list-item" onClick={() => downloadDocument(file.faqFileId, file.name)} title={`Ladda ner ${file.name}`}>
                                <div className="col-12 download">
                                    <div className="row">
                                        <p className="col-8">{file.name}</p>
                                        <span className="col-4"><FontAwesomeIcon icon={faDownload} /></span>
                                    </div>
                                </div>
                            </li>
                        )
                    }
                </ul>
            </div>
        }
    }

    const downloadDocument = (librettoFileId: number, fileName?: string) => {
        api.downloadFaqAttachment(librettoFileId, fileName,
            (error) => {
                alert(error);
            });
    }

    return (
        <Modal id="faq-modal" preventCloseOnOutsideClick={false} header={modalData?.question ? modalData?.question : ""} modalSize={ModalSize.large}>
            <ModalBody>
                <span style={{ whiteSpace: "pre-wrap" }}>
                    {modalData?.answer}
                </span>
            </ModalBody>
            {renderLinks()}
            {renderDocuments()}
            <ModalFooter>
                <div className="text-right btn-group" role="group">
                    <input type="button" data-dismiss="modal" id="close-modal" className="btn btn-sm" value="Stäng" />
                </div>
            </ModalFooter>
        </Modal>
    );

}